import { atom } from 'recoil';

const startTrailTimeState = atom({
  key: 'startTrailTimeState',
  default: 0,
});

export default startTrailTimeState;
